import {createMultiStyleConfigHelpers} from '@chakra-ui/styled-system';

const helpers = createMultiStyleConfigHelpers([
  'container',
  'imageContainer',
  'imageLink',
  'image',
  'content',
  'category',
  'title',
  'tagsContainer',
  'tag',
  'tagText'
]);

export const blogSummaryStyles = helpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: {base: 4, md: 6},
      alignSelf: 'stretch',
      flex: '1 0 0',
      transition: 'transform 0.2s ease',
      cursor: 'pointer',
      _hover: {
        transform: 'translateY(-2px)',
      },
    },

    imageContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      alignSelf: 'stretch',
      aspectRatio: {base: '67/60', md: '1/1'},
      overflow: 'hidden',
    },

    imageLink: {
      display: 'block',
      width: '100%',
      height: '100%',
    },

    image: {
      width: '100%',
      height: '100%',

      sx: {
        img: {
          width: '100%',
          height: '100%',
          objectFit: 'cover',
        },
      },
    },

    content: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: {base: 4, md: 2},
      alignSelf: 'stretch',
    },

    category: {
      alignSelf: 'stretch',
      color: 'brandColors.primaryDarkLinen',
      fontFamily: 'heading',
      fontSize: '10px',
      fontWeight: '600',
      lineHeight: '120%',
      letterSpacing: '2px',
      textTransform: 'uppercase',
    },

    title: {
      alignSelf: 'stretch',
      color: 'brandColors.greyscale90',
      fontFamily: 'heading',
      fontSize: {base: '16px', md: '20px'},
      fontWeight: '500',
      lineHeight: '120%',
      letterSpacing: {base: '0', md: '-0.24px'},
      mb: 0,
    },

    tagsContainer: {
      display: 'flex',
      alignItems: 'flex-start',
      gap: 2,
      flexWrap: 'wrap',
    },

    tag: {
      display: 'flex',
      padding: '4px 8px',
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: '32px',
      border: '1px solid',
      borderColor: 'brandColors.primaryLinen03',
      backgroundColor: 'transparent',
    },

    tagText: {
      color: 'brandColors.greyscale90',
      fontSize: '12px',
      fontWeight: '400',
      lineHeight: '140%',
    },
  },

  variants: {
    /**
     * Featured variant - horizontal layout with large image
     */
    featured: {
      container: {
        display: 'flex',
        flexDirection: {base: 'column', md: 'row'},
        alignItems: 'stretch',
        gap: 0,
        width: '100%',
        _hover: {
          transform: 'none',
        },
      },

      imageContainer: {
        flex: {base: '1', md: '0 0 65%'},
        aspectRatio: {base: '335/300', md: '840/468'},
        overflow: 'hidden',
      },

      imageLink: {
        display: 'block',
        width: '100%',
        height: '100%',
      },

      image: {
        width: '100%',
        height: '100%',

        sx: {
          img: {
            width: '100%',
            height: '100%',
            objectFit: 'cover',
          },
        },
      },

      content: {
        flex: {base: '1', md: '0 0 35%'},
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        alignItems: 'flex-start',
        gap: {base: 4, md: 4},
        padding: {base: '32px 20px', md: '48px'},
        backgroundColor: 'brandColors.primaryBG',
      },

      category: {
        color: 'brandColors.primaryDarkLinen',
        fontFamily: 'heading',
        fontSize: '10px',
        fontWeight: '600',
        lineHeight: '120%',
        letterSpacing: '2px',
        textTransform: 'uppercase',
      },

      title: {
        color: 'brandColors.greyscale90',
        fontFamily: 'heading',
        fontSize: {base: '24px', md: '32px'},
        fontWeight: '400',
        lineHeight: '120%',
        letterSpacing: {base: '-0.24px', md: '-0.32px'},
        mb: 0,
      },

      tagsContainer: {
        display: 'none',
      },

      tag: {
        display: 'none',
      },

      tagText: {
        display: 'none',
      },
    },
  },
});
